import { render } from "./SiteBar.vue?vue&type=template&id=0b20cb0f"
import script from "./SiteBar.vue?vue&type=script&lang=js"
export * from "./SiteBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__